import {Component, OnInit} from '@angular/core';

import {DateAdapter, NativeDateAdapter} from '@angular/material';
import {DatePipe} from '@angular/common';

import {TransferRequestService} from './transfer-request.service';

@Component({
    selector: 'app-transfer-request',
    templateUrl: './templates/transfer-request.component.html',
    styleUrls: ['./styles/transfer-request.component.css']
})
export class TransferRequestComponent implements OnInit {
    validate_bt: boolean = true;

    warehouse: string;
    warehouses_list: Array<any>;

    no_transaction: string;
    transaction_date: Date;
    transaction_name: string = "";
    remark: string = "";
    session_mode: string = "RECEPTION";

    panier_list: Array<any> = [];

    constructor(
        private transfer_request_service: TransferRequestService,
        dateAdapter: DateAdapter<NativeDateAdapter>,
        private datepipe: DatePipe,
    ) {
        dateAdapter.setLocale('fr-FR');
        this.transaction_date = new Date();
    }

    ngOnInit() {
        this.LoadSessionTransfer();
    }

    articleToSend(event: any) {
        this.AddToPanier(event);
    }

    resetPannier() {
        this.panier_list = [];
    }

    AddToPanier(prod: any): void {
        var date = (this.datepipe.transform(this.transaction_date, 'dd-MM-yyyy'));
        this.transfer_request_service.AddtoPannier(prod)
            .then(panier_list => {
                this.panier_list = panier_list['list'].reverse();
                if (panier_list['list'].length !== 0) {
                    this.validate_bt = false
                }
            });
    }

    EditAndValidate(item: any, idx: number): void {
        if (item.status === "RECEPTION") {
            this.EditArticleSession(item);
        } else if (item.status === 'MODIFICATION') {
            this.ValidateEditArticleSessionPurchase(item, idx);
        }
    }

    RemoveFromPanier(item: any): void {
        this.transfer_request_service.RemoveFromPanier(item.id_article)
            .then(panier_list => {
                this.panier_list = panier_list['list'].reverse();
                if (panier_list['list'].length === 0) {
                    this.validate_bt = true;
                    this.transaction_name = "";
                }
            });
    }

    EditArticleSession(prod: any): void {
        this.transfer_request_service.EditLineSessionTransfer(prod.id_article)
            .then(result => {
                this.panier_list = result['list'].reverse();
                this.SessionMod(result['list']);;
            });
    }

    ValidateEditArticleSessionPurchase(item: any, idx: number): void {
        if (isNaN(item.quantity)) {
            item.quantity = "Valeur invalide";
            setTimeout(() => {this.LoadSessionTransfer()}, 3500);
        }
        else {
            this.transfer_request_service.ValidateEditionSessionTransfer(item)
                .then(result => {
                    this.panier_list = result['list'].reverse();
                    this.SessionMod(result['list']);
                });
        }
    }

    LoadSessionTransfer() {
        this.transfer_request_service.LoadSessionTransfer()
            .then(session_list => {
                this.panier_list = session_list['list'].reverse();
                if (session_list['list'].length !== 0) {
                    this.validate_bt = false
                }
            });
    }

    SessionMod(list: any): void {
        this.session_mode = "RECEPTION";
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === "MODIFICATION") {
                this.session_mode = "MODIFICATION";
            }
        }
    }

    validatePanier(): void {
        if (this.transaction_name !== "" && this.no_transaction != "" && this.panier_list.length !== 0) {
            let temp = this.datepipe.transform(this.transaction_date, 'yyyy-MM-dd');
            let date_email = this.datepipe.transform(this.transaction_date, 'dd-MM-yyyy');
            this.transfer_request_service.ValidatePanierTransfer(this.transaction_name, this.remark, this.no_transaction, temp)
                .then(result => {
                    this.panier_list = result['list'];
                    //                    this.send_mail_component.setValues("demande d'achat", this.transaction_name, this.no_transaction, date_email, result['id_transaction_details']);
                    this.transaction_name = "";
                    this.no_transaction = "";
                    this.remark = "";
                    this.transaction_date = new Date();
                    this.validate_bt = true;
                    //                    this.send_mail_component.sendAnEmail();
                });
        } else {
            //            this.form_not_valid = true;
            //            setTimeout(() => {this.form_not_valid = false;}, 4000);
        }
    }

    cancelPanier() {

    }

    onDateChanged(event) {
        var date = (this.datepipe.transform(event, 'dd-MM-yyyy'));
    }

}



// WEBPACK FOOTER //
// ./src/app/transfer-request.component.ts